import React from 'react';
import propTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames';
import { DELAY, GRID_STYLE } from '../../constants';

const LeaseCard = ({ classList, cardNumber }) => {
  const showCarCards = useSelector((state) => state.catalog.showCarCards);
  const pageViewStyle = useSelector((state) => state.catalogStyle.style);
  const { language, dictionary } = startup;

  const src1 = pageViewStyle === GRID_STYLE ? 'grid-1.png' : 'list-1.png';
  const src2 = pageViewStyle === GRID_STYLE ? 'grid-2.png' : 'list-2.png';

  const leaseCardClassList = window.location.href.includes('catalog')
    ? classNames('lease-card', 'lease-card-catalog')
    : classNames('lease-card', 'lease-card-main');

  const leaseCardwrapperClassList =
    pageViewStyle === GRID_STYLE
      ? classNames('lease-card-wrapper', 'grid-card-wrapper overflow-hidden')
      : classNames('lease-card-wrapper', 'list-card-wrapper overflow-hidden');

  return (
    <CSSTransition
      in={showCarCards}
      timeout={DELAY + cardNumber * 100}
      unmountOnExit // important!!!
      classNames="catalog"
    >
      <div className={classList}>
        <div className={leaseCardwrapperClassList}>
          <div className="inner-wrapper">
            <div
              className={leaseCardClassList}
              style={{
                backgroundImage: `url(../../../media/content/catalog-lease/${src1})`,
              }}
            >
              <h3>{dictionary.LeaseSlide1Title}</h3>
            </div>
            <div
              className={`${leaseCardClassList} card-2`}
              style={{
                backgroundImage: `url(../../../media/content/catalog-lease/${src2})`,
              }}
            >
              <h3>{dictionary.LeaseSlide2Title}</h3>
            </div>
          </div>
          <a
            className="b-find__btn btn btn-primary sp-layer"
            href={`../../../${language}/leasing`}
          >
            {dictionary.LeaseButton}
          </a>
        </div>
      </div>
    </CSSTransition>
  );
};

export default LeaseCard;

LeaseCard.propTypes = {
  classList: propTypes.string.isRequired,
  cardNumber: propTypes.number.isRequired,
};
